// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { alertService } from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
  getActivityEquipment,
  insertactivityequipment,
  activityequipmentSelector,
  updateactivityequipment,
} from "./activityequipmentSlice";

import { Colors } from "../../../assets/Colors";
import { maxPageGlobal } from "../../../assets/config";

const ActivityequipmentPage = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(maxPageGlobal);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [insertFetch, setInsertFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const activityequipment = useSelector(activityequipmentSelector);

  useEffect(() => {
    dispatch(
      getActivityEquipment({
        start: start,
        count: count,
        search: "",
      })
    );
  }, []);

  useEffect(() => {
    if (
      search !== "" &&
      activityequipment.isGetSuccess &&
      !activityequipment.isGetFetching
    ) {
      let calc = activityequipment?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = activityequipment.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    } else if (
      search === "" &&
      activityequipment.isGetSuccess &&
      !activityequipment.isGetFetching
    ) {
      let calc = activityequipment?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = activityequipment.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    }

    if (
      !activityequipment?.isGetFetching &&
      activityequipment.isGetSuccess &&
      maxPage === 0 &&
      firstLoading === false
    ) {
      let calc = activityequipment?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = activityequipment.data ? Math.ceil(calc / count) : 1;
      setMaxPage(tempMaxPage);
      setFirstLoading(true);
      dispatch(
        getActivityEquipment({
          start: start,
          count: count,
          search: search,
        })
      );
    }

    if (insertFetch) {
      setInsertFetch(false);
      if (activityequipment.isGetSuccess) {
        alertService.success(activityequipment.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          getActivityEquipment({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (activityequipment.isUpdateSuccess) {
        alertService.success(activityequipment.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          updateactivityequipment({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }
  });

  // function handlegetActivityEquipment(params) {
  //   return dispatch(getActivityEquipment(params));
  // }

  function handleInsertActivity(param) {
    setInsertFetch(true);
    const params = {
      ActivityEquipment: param.inputOneValue,
    };
    dispatch(insertactivityequipment(params));
  }

  function handleUpdateActivity(param) {
    setUpdateFetch(true);

    const params = {
      ActivityEquipment: param.inputOneValue,
      ID: currentData.ID,
    };

    dispatch(updateactivityequipment(params));
  }

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 5,
      search: searchValue,
    };
    dispatch(getActivityEquipment(params));

    setStart(0);
    setCount(5);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    let params = {
      start: newStart,
      count: count,
      search: search,
    };
    dispatch(getActivityEquipment(params));

    setPage(newPage);
    setStart(newStart);
  }

  function handleUpdateCount(newCount) {
    let calc = activityequipment.count - 1;
    if (calc === 0) {
      calc = 1;
    }

    let params = {
      start: newCount === "-1" ? 0 : start,
      count: newCount === "-1" ? activityequipment.count : newCount,
      search: search,
    };
    dispatch(getActivityEquipment(params));

    setPage(1);
    setCount(newCount === "-1" ? activityequipment.count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
  }

  if (!firstLoading) {
    return <div>loading</div>;
  } else {
    return (
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <TableCard
                backButton={true}
                backUrl={"master"}
                handleSearch={handleSearch}
                searchPlaceholder="Activity"
                updatePage={handleUpdatePage}
                updateCount={handleUpdateCount}
                currentData={handleCurrentData}
                currentPage={page}
                maxPage={maxPage}
                tableTitle="Master Activity"
                tableData={activityequipment.data}
                colOneTitle="ID"
                colOneData="ID"
                colTwoTitle="Activity"
                colTwoData="Activity"
                fetching={activityequipment.isGetFetching}
                modal={handleModal}
                editEnabled={true}
              />
            </div>
          </div>
        </div>
        {showModalAdd && (
          <ModalForm
            showModal={showModalAdd}
            // addEnabled={true}
            modal={handleModal}
            modalTitle="Tambah Activity"
            inputOneTitle="Nama Activity"
            inputOnePlaceholder=""
            submitButtonTitle="Submit"
            handleSubmit={handleInsertActivity}
          />
        )}
        {showModalEdit && (
          <ModalForm
            showModal={showModalEdit}
            // editEnabled={true}
            id={currentData.ID}
            modal={handleModal}
            modalTitle="Ubah Activity"
            inputOneTitle="Activity"
            inputOneValue={currentData.Activity}
            submitButtonTitle="Submit"
            handleSubmit={handleUpdateActivity}
          />
        )}
      </div>
    );
  }
};

export default ActivityequipmentPage;
